export class BaseDiscrepancyMetrics {
  BASE_DISCREPANCY_ISN: number;
  DSCRP_NBR: string;
  ACN: string;
  ORIGINAL_ATA_CHR: string;
  ATA: string;
  ATA_CHAPTER: string;
  ATA_DESC: string;
  ACN_REGN: string;
  FLEET_CD: string;
  FLEET: string;
  ENGINE_MFG: string;
  DSCRP_TYPE: string;
  DSCRP_TYPE_DESC: string;
  STATUS: string;
  OPEN_STA: string;
  FACT_STA: string;
  OPEN_DTM: Date;
  FACT_DTM: Date;
  RECODED_CORR_ACT_ATA: string;
  REPORTING_CORR_ACT_ATA: string;
  RECODED_MLFN_CD: string;
  RECODED_MLFN_CD_DESC: string;
  RECODED_FIX_CD: string;
  RECODED_FIX_CD_DESC: string;
  MEL_CONTROL_NBR: number;
  MEL_NBR: string;
  MEL_CATEGORY: string;
  MEL_IND: number;
  OOS_EVENT_HRS: number;
  OOS_EVENT_MIN: number;
  OOS_EVENT_CNT: number;
  FLT_ZULU_DT: Date;
  FLT_NBR: string;
  ORIG_IATA_CD: string;
  REL_DSCRP_ACN: number;
  REL_DSCRP_ATA: number;
  REL_DSCRP_NBR: number;
  REL_PRIMARY_DISCREPANCY_CD: number;
  REL_1ST_DELAY_CD: string;
  REL_DLY_CNL_IND: string;
  M2_CNT: number;
  DLY_CNT: number;
  CNL_CNT: number;
  M2_DLY_CNT: number;
  M2_CNL_CNT: number;
  ATB_CNT: number;
  BTB_CNT: number;
  DIV_CNT: number;
  IFSD_CNT: number;
  OTHR_CNT: number;
  RTO_CNT: number;
  SMK_CNT: number;
  DAMAGE_CNT: number;
  REL_SWAPPED_AC_CNT: number;
  EMER_CNT: number;
  TFOA_CNT: number;
  REL_DLY_MIN: number;
  DLY_15_MIN_IND: number;
  DLY_30_MIN_IND: number;
  M2_DLY_15_MIN_CNT: number;
  M2_DLY_30_MIN_CNT: number;
  REL_FIX_CODE: string;
  REL_FIX_CODE_DESC: string;
  REL_ETOPS_IND: number;
  REL_MIS_IND: number;
  REL_READI_IND: number;
  WDL_PACKAGE_CNT: number;
  WDL_DELAY_MIN: string;
  RDL_PACKAGE_CNT: number;
  SHOTGUN_COUNT_TOTAL: number;
  SHOTGUN_COUNT_FAULTS: number;
  ATA_CHAPTER_DESC: string;
  ATA_SUBCHAPTER_DESC: string;
  ORIGINAL_ATA_DESC: string;
  RECODED_CORR_ACT_ATA_DESC: string;
  REPORTING_CORR_ACT_ATA_DESC: string;
  REPORTING_CORR_ACT_ATA_SOURCE: string;
  ORIGINAL_ATA_CHPT: string;
  ORIGINAL_ATA_SUB_CHPT: string;
  REPORTING_CORR_ACT_ATA_CHAPTER: string;
  REPORTING_CORR_ACT_ATA_CHAPTER_DESC: string;
  DISCREPANCY_TEXT: string;
  EXTENDED_CORRECTIVE_ACTION: string;
  AC_TOTAL_CYCLES_OPEN_DT: number;
  AC_TOTAL_HRS_OPEN_DT: number;
  AC_TOTAL_CYCLES_FACT_DT: number;
  AC_TOTAL_HRS_FACT_DT: number;
  REL_ANALYST_DISCREP_COMMENT: string;
  REL_ANALYST_CORR_ACT_COMMENT: string;
  AI_FLIGHT_PHASE: string;
  AI_FLIGHT_PHASE_EXPLANATION: string;
  DELAY_COST: number;
  ATB_COST: number;
  DIV_COST: number;
  RTO_COST: number;
  IFSD_COST: number;
  EMER_COST: number;
  OOS_EVENT_COST: number;
  OOS_DIRECT_COST: number;
  OOS_INDIRECT_COST: number;
  PDIS_COST: number;
  WDL_COST: number;
  RDL_COST: number;
  PAIN_VALUE: number;
}
